import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { observer } from 'mobx-react';
import OptimizeImagesService from 'services/OptimizeImages.service';

import messages from './MissionAndVisionView.intl';

import styles from './MissionAndVisionView.module.scss';

import { Container, Title } from 'common/components/Layout/Layout';
import BigInfoBox from './components/BigInfoBox/BigInfoBox';
import SmallInfoBox from './components/SmallInfoBox/SmallInfoBox';

import ContentStore from 'stores/Content.store';
import InjectMetaTags from 'common/components/InjectMetaTags/InjectMetaTags';

import Placeholder from 'common/components/Placeholder/Placeholder';
import MissionAndVisionPlaceholder from './placeholder/MissionAndVisionPlaceholder';

@injectIntl
@observer
export default class MissionAndVisionView extends Component {
  render() {
    const content = ContentStore.content;

    return (
      <div>
        {ContentStore.isLoaded && (
          <InjectMetaTags {...ContentStore.content.missionAndVisionSEO} />
        )}
        <Container>
          <Title title={this.props.intl.formatMessage(messages.heading)} />
        </Container>
        <Placeholder
          component={<MissionAndVisionPlaceholder />}
          ready={!!content}
        >
          {ContentStore.isLoaded && (
            <div
              className={styles.MissionAndVisionContainer}
              style={{
                backgroundImage: `url(${OptimizeImagesService.adjustImageSize(
                  content.missionAndVisionImage
                )})`
              }}
            >
              <Container>
                <div className={styles.MissionAndVisionMainContent}>
                  {content.missionAndVisionMainContent.map((item, index) => (
                    <div
                      key={index}
                      className={styles.MissionAndVisionBigBoxColumn}
                    >
                      <BigInfoBox item={item} />
                    </div>
                  ))}
                </div>
              </Container>
              <div className={styles.SecondSectionBackground}>
                <Container>
                  <div className={styles.SecondSectionContent}>
                    <div className={styles.SecondSectionTitle}>
                      <h2>
                        {this.props.intl.formatMessage(messages.valuesWeBelive)}
                      </h2>
                    </div>
                    <div className={styles.MissionAndVisionMainSmallBoxContent}>
                      {content.missionAndVisionValuesWeBelieve.map(
                        (item, i) => (
                          <div
                            key={i}
                            className={styles.MissionAndVisionSmallBoxColumn}
                          >
                            <SmallInfoBox item={item} />
                          </div>
                        )
                      )}
                    </div>
                  </div>
                </Container>
              </div>
            </div>
          )}
        </Placeholder>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/MissionAndVision/MissionAndVisionView.js